import { useTranslation } from "@/hooks/useTranslation";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

export const LanguageSwitcher = () => {
  const { language, setLanguage, t, languageOptions } = useTranslation();

  const handleLanguageChange = (value: string) => {
    setLanguage(value);
  };

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold mb-2">{t("settings.language")}</h3>
        <p className="text-sm text-muted-foreground mb-4">
          {t("bootstrap.choose_language_hint")}
        </p>
      </div>

      <RadioGroup value={language} onValueChange={handleLanguageChange}>
        {languageOptions.map((opt) => (
          <div
            key={opt.code}
            className="flex items-center space-x-2 p-3 rounded-lg border cursor-pointer"
          >
            <RadioGroupItem value={opt.code} id={`lang-${opt.code}`} />
            <Label htmlFor={`lang-${opt.code}`} className="flex-1 cursor-pointer">
              <div className="font-medium">{opt.nativeName}</div>
              <div className="text-sm text-muted-foreground">{opt.code.toUpperCase()}</div>
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};
